import AiResearchNode from './ai-research-node';

export default AiResearchNode;
